export function getUsageAgreementStatusView(status = {}, hasMasterData = false) {
  const fallback = hasMasterData
    ? { state: 'data_available', label: 'Stammdaten vorhanden' }
    : { state: 'not_prepared', label: 'Nicht vorbereitet' };
  const normalized = { ...fallback, ...status };
  const tone = normalized.state === 'created' || normalized.state === 'data_available'
    ? 'success'
    : normalized.state === 'failed' || normalized.state === 'scope_conflict'
      ? 'danger'
      : normalized.state === 'creating' ? 'warning' : 'neutral';
  return { ...normalized, tone };
}
